module.exports = __webpack_public_path__ + "img/1112.96f6ea5b.jpg";